import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ApiLog, ApiLogsState } from '@/types/log.types';

const initialState: ApiLogsState = {
  list: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const apiLogsSlice = createSlice({
  name: 'apiLogs',
  initialState,
  reducers: {
    fetchApiLogsRequest(state, _action: PayloadAction<{ page: number; limit: number; search?: string; companyId?: string; dateFrom?: string; dateTo?: string }>) {
      state.loading = true; state.error = null;
    },
    fetchApiLogsSuccess(state, action: PayloadAction<{ list: ApiLog[]; totalCount: number }>) {
      state.loading = false; state.list = action.payload.list; state.totalCount = action.payload.totalCount;
    },
    fetchApiLogsFailure(state, action: PayloadAction<string>) {
      state.loading = false; state.error = action.payload;
    },
  },
});

export const {
  fetchApiLogsRequest, fetchApiLogsSuccess, fetchApiLogsFailure,
} = apiLogsSlice.actions;
export default apiLogsSlice.reducer;
